import { api } from "./client";

export function getReports(params?: {
  page?: number;
  pageSize?: number;
  source?: string;
}) {
  return api.get("/reports", { params });
}

export function getReport(id: string, params?: { view?: boolean }) {
  return api.get(`/reports/${id}`, { params });
}

export function generateReport(data: Record<string, unknown>) {
  return api.post("/reports/generate", data);
}

export function uploadReport(data: FormData) {
  return api.post("/reports/upload", data, { isFormData: true });
}

export function deleteReport(id: string) {
  return api.delete(`/reports/${id}`);
}
